var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showLoading)?_c('div',{staticClass:"loading"},[_c('v-progress-circular',{attrs:{"size":50,"color":"#ad1f25","indeterminate":""}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }